<template>
  <div>
    <NotFound
        type="ok"
        btn="publicar"
        :btnFunction="handlePublicar"
        title="Publicar"
        text="Esta alocação estará pública. Atenção: Caso já exista uma alocação pública, será removida e substituída por esta."
    />
  </div>
</template>

<script>
import { handlePublishPaasSolution } from "@/api/db";
import NotFound from '@/components/NotFound.vue';

export default {
  name: "HandlePublicPlan",
  props: {
    plan: Object
  },
  components: {
    NotFound,
  },
  methods: {
    handlePublicar() {
      handlePublishPaasSolution(this.plan);
      setTimeout(() => {
        this.$router.push({ path: "/paas-publicar" });
      }, 1000);
    }
  }
};
</script>
